import type { UserType } from './user.interface';

export interface UserActionRequest {
  accountId?: string;
  postId: string;
  commentId?: string;
  actionType: ActionType;
  userType?: UserType;
  externalUserId?: string;
}

export enum ActionType {
  VIEW = 'VIEW',
  LIKE = 'LIKE',
  REMOVE_LIKE = 'REMOVE_LIKE',
  CLICK = 'CLICK',
  CONVERT = 'CONVERT',
}
